/**
 * Build a message to be populated in a tooltip if the select is disabled
 *
 * @param {boolean} loading
 * @param {boolean} error
 * @param {string} selectedIntegrationId
 * @param {string} defaultIntegrationId
 * @returns {string | null} The disabled message
 */
export default function buildRevisionSelectDisabledMessage({
  loading,
  error,
  selectedIntegrationId,
  defaultIntegrationId,
}) {
  const isNotDisabled = !loading && !error && selectedIntegrationId !== defaultIntegrationId;
  if (isNotDisabled) {
    return null;
  }

  if (loading) {
    return 'Loading revisions...';
  }

  if (error) {
    return 'Error loading integrations';
  }

  if (selectedIntegrationId === defaultIntegrationId) {
    return 'Select an integration';
  }

  return 'No revisions configured';
}
